/*
 * Copyright (c) 2024. Tooling Team
 */

import PropTypes from "prop-types";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";

export function formatLongDescription(value) {
  if (value === null || value === undefined || value === "") {
    return "None";
  }

  if (typeof value === "string") {
    const trimmed = value.trim();

    if (trimmed === "") {
      return "None";
    }

    const firstChar = trimmed[0];

    if (firstChar !== "{" && firstChar !== "[") {
      return value;
    }

    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      return value;
    }
  }

  return JSON.stringify(value, null, 2);
}

function hasLongDescription(value) {
  return typeof value === "string" ? value.trim() !== "" : !!value;
}

const PopOverCell = ({ displayNone, displayLong, showFullContent }) => {
  if (showFullContent) {
    return <span>{displayNone}</span>;
  }

  const popover = (
    <Popover className="popover" id="popover-basic">
      <Popover.Header as="h3">Description</Popover.Header>
      <Popover.Body>{displayNone}</Popover.Body>
      <Popover.Header as="h3">JSON Data</Popover.Header>
      <Popover.Body>
        <pre>{displayLong}</pre>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="localDescIcon mt-2andaBit fa-lg localDescIconCustom">
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="right"
        overlay={popover}
      >
        <div>
          <FontAwesomeIcon icon={regular("rectangle-list")} />
        </div>
      </OverlayTrigger>
    </div>
  );
};

PopOverCell.propTypes = {
  displayNone: PropTypes.string.isRequired,
  displayLong: PropTypes.string.isRequired,
  showFullContent: PropTypes.bool,
};

//cell renderer for Local and Standard description. Since it's used by both, generic variables and string manipulation to get tooltip header.
export default function LongDescriptionCellRenderer(params) {
  let standardDescription = params.data["standardDescription"];
  let longDescription = params.data["standardLongDescription"];
  let displayNone =
    standardDescription && standardDescription != ""
      ? standardDescription
      : "None";
  let displayLong = formatLongDescription(longDescription);
  if (!hasLongDescription(longDescription)) {
    if (standardDescription) {
      //16 is default width of current description cols
      if (standardDescription.length > 16) {
        return (
          <PopOverCell
            displayNone={displayNone}
            displayLong={displayLong}
            showFullContent={params?.showFullContent}
          />
        );
      } else {
        return standardDescription;
      }
    } else {
      return null;
    }
  } else {
    return (
      <PopOverCell
        displayNone={displayNone}
        displayLong={displayLong}
        showFullContent={params?.showFullContent}
      />
    );
  }
}
